import axios from "axios";
import axiosInstance from "../api";

// Fetches the short-lived gate token that authorizes the login call itself.
// Pure API call — no side effects. Session clearing/committing is owned by the
// login flow so a failed attempt can be rolled back atomically.
export const CheckAuth = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_ENDPOINT}/auth/token/generate`
  );
  return response;
};

export const LoginAPI = async (data) => {
  try {
    // ✅ Correct endpoint
    const response = await axiosInstance.post("admin/auth/login", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const issueToken = async (data) => {
  try {
    // ✅ Use full URL instead of relative path
    const response = await axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/auth/token/validate`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Plain axios, not the instance: a renewal must not pass through the
// interceptors that trigger renewals. Every request waiting on a renewal waits
// on this call, so it has a limit; without one a stalled connection kept whole
// pages on their loaders.
export const refreshToken = (data) =>
  axios.post(`${process.env.REACT_APP_API_ENDPOINT}/auth/token/refresh`, data, {
    timeout: 15000,
  });
